import {
	Box,
	Heading,
	Spinner,
	TabContent,
	TabItem,
	Tabs,
	TabsList,
	Icons,
	Inline,
} from "@sembark-travel/ui/base"
import { Breadcrumbs } from "@sembark-travel/ui/router"
import { Helmet } from "react-helmet-async"
import { generatePath, redirect } from "../../../../router-utils"
import { UserDetails, UsersXHR, IUser } from "./../../../../Users"
import {
	LoaderFunctionArgs,
	useLoaderData,
	Await,
	useRevalidator,
} from "react-router"
import { xhr } from "@sembark-travel/xhr"
import { Suspense } from "react"
import { ActivityLogs } from "../../../../ActivityLogs"

export async function Loader({ params }: LoaderFunctionArgs) {
	if (!params.userId) {
		return redirect("/org/users")
	}
	const user = UsersXHR(xhr).getUser(params.userId)
	return { user }
}

export default function User() {
	const { user } = useLoaderData() as { user: Promise<IUser> }
	const revalidator = useRevalidator()
	return (
		<>
			<Helmet>
				<title>User Details</title>
			</Helmet>

			<Suspense fallback={<Spinner padding="4" alignCenter />}>
				<Await resolve={user}>
					{(user: IUser) => (
						<>
							<Breadcrumbs
								title="User Details"
								items={[
									[
										user.tenant_id
											? generatePath("/org/users")
											: generatePath("/admin/users"),
										"Users",
									],
									["", "Details"],
								]}
							/>

							<Tabs defaultActive="basicDetails">
								<TabsList>
									<TabItem id="basicDetails">
										Basic Details <Icons.NewFeature size={"10"} />
									</TabItem>
									<TabItem id="securityLogs">Security Logs</TabItem>
								</TabsList>
								<TabContent
									id="basicDetails"
									unmountOnInactive
									key="basicDetails"
								>
									<UserDetails
										user={user}
										onChange={() => revalidator.revalidate()}
									/>
								</TabContent>
								<TabContent
									id="securityLogs"
									unmountOnInactive
									key="securityLogs"
								>
									<Box padding="4">
										<Inline alignItems="center" gap={"1"}>
											<Icons.Security size="6" />
											<Heading fontSize="lg">Security Logs</Heading>
										</Inline>
										<ActivityLogs
											causerType="users"
											causerId={user.id}
											securityLogs
										/>
									</Box>
								</TabContent>
							</Tabs>
						</>
					)}
				</Await>
			</Suspense>
		</>
	)
}
